import { colors } from '../../../../../../../../../colorVars';
import { Body3 } from '../../../../../../../../../components/atomic/text/Text';
import ApplyRounding from '../../../../../../../../../utils/math/ApplyRounding';

export function tightSpreadCentsBuilder({parsedStatusObj}) {
  const { cents } = parsedStatusObj;
  return (
    <td>
      <Body3 fontWeight={500} color={colors.lightGrey}>
        Tight spread filter failed. Max spread:{' '}
        {cents ? '$' + ApplyRounding(Number(cents), 2) : 'unknown'}.
      </Body3>
    </td>
  );
}
